export const ERROR_TYPES = {
    NETWORK_ERROR: [
        "Network error",
        "timeout of 0ms exceeded"
    ],
    KNOWN_ERRORS: [
        "ConversationIdNullException",
        "Event Id: 635080209 errored, max retries attempted",
        "'NoneType' object has no attribute 'gmail_label_id'",
        "'NoneType' object is not iterable"
    ],
    API_ERRORS: [
        "Request failed with status code 401",
        "Request failed with status code 500",
        "Request failed with status code 400"
    ],
    TO_DEBUG: []
}